<template>
    <v-card elevation="0">
        <v-card-title class="mt-n2">
            <div class="headline">{{$t('app_drawer.app')}}</div>
            <v-spacer></v-spacer>
            <v-btn color="primary" :to="{name: 'mobile-app-add'}">
                {{$t('mobile_app.create')}}
                <v-icon right>mdi-plus</v-icon>
            </v-btn>
        </v-card-title>
        <v-card-text>
            <v-row>
                <v-col>
                    <v-select clearable
                              :label="$t('event.companyId')"
                              :placeholder="$t('event.companyId')"
                              :items="companyOptions"
                              v-model="filterByCompanyId">
                    </v-select>
                </v-col>
                <v-col>
                    <v-text-field v-model="search"
                                append-icon="mdi-magnify"
                                :label="$t('search')"
                                single-line
                                hide-details>
                    </v-text-field>
                </v-col>
            </v-row>
            
            <v-data-table :headers="headers"
                        :items="mobileApps"
                        :no-data-text="filterByCompanyId ? 'No data available' : 'Please Select Company'"
                        :search="search">
                <template v-slot:item.companyId="{value}">
                    {{(companyMap[value])?companyMap[value].name:""}}
                </template>
                <template v-slot:item.createdAt="{value}">
                    {{DateTime.fromISO(value).toFormat('yyyy-MM-dd HH:mm')}}
                </template>
                <template v-slot:item.updatedAt="{value}">
                    {{DateTime.fromISO(value).toFormat('yyyy-MM-dd HH:mm')}}
                </template>
                <template v-slot:item.actions="{item}">
                    <v-btn color="primary"
                        :to="{name: 'mobile-app-edit', params: {mobileAppId:item.id}}">
                        {{$t('edit')}}
                        <v-icon right>mdi-pencil</v-icon>
                    </v-btn>
                </template>
            </v-data-table>
        </v-card-text>
    </v-card>

</template>

<script>
    import {computed, ref, watch} from "@vue/composition-api";
    import {useFind} from "feathers-vuex";
    import {DateTime} from "luxon";

    export default {
        name: 'MobileAppList',
        setup(props, {root}) {
            const {MobileApp, Company} = root.$FeathersVuex.api;

            const companyParams = computed(() => {
                return {
                    query: {
                        $sort: {
                            name: 1,
                        }
                    }
                }
            });
            const companyData = useFind({model: Company, params: companyParams});
            const companyMap = computed(() => {
                let map = {};

                companyData.items.value.forEach(c => {
                    map[c.id] = c;
                });

                return map;
            });
            
            const companyOptions = computed(() => {
                return companyData.items.value.map(c => {
                    return {text: c.name, value: c.id}
                });
            });
            
            const filterByCompanyId = ref(root.$store.state.prefilledCompanyId);
            watch(filterByCompanyId, (companyId) => {
                root.$store.commit('setPrefilledCompanyId', companyId || '');
            });

            const mobileAppParams = computed(() => {
                let params = {
                    query: {
                        $sort: {
                            name: 1,
                        }
                    }
                };

                if (filterByCompanyId && filterByCompanyId.value) {
                    params.query['companyId'] = filterByCompanyId.value;
                } else {
                    // params.query['id'] = 0;
                }
                return params;
            });
            const mobileAppData = useFind({model: MobileApp, params: mobileAppParams});

            // Data Table
            const search = ref('');
            const headers_init = [
                {text: root.$t('mobile_app.name'), value: 'name'},
                {text: root.$t('mobile_app.app_id'), value: 'app_id'},
                {text: root.$t('mobile_app.app_type'), value: 'app_type'},
                {text: root.$t('mobile_app.company'), value: 'companyId'},
                {text: root.$t('mobile_app.created_at'), value: 'createdAt', filterable: false},
                {text: root.$t('mobile_app.updated_at'), value: 'updatedAt', filterable: false},
                {text: '', value: 'actions', filterable: false, width: '120', align: 'end'},
            ];
            
            const headers = computed(() => {
                return headers_init.filter((col) => (col.value !== 'companyId' || !(filterByCompanyId && filterByCompanyId.value)));
            });

            return {
                mobileApps: mobileAppData.items,

                companyMap,

                search,
                headers,
                DateTime,
                
                companyOptions,
                filterByCompanyId
            }
        }
    }
</script>
